import types from '../types'

const outboundDepartureTimesInitialized = (time) => ({
  type: types.OUTBOUND_DEPARTURE_TIME_INITIALIZED,
  time,
})

const inboundDepartureTimesInitialized = (time) => ({
  type: types.INBOUND_DEPARTURE_TIME_INITIALIZED,
  time,
})

const updateTransfer = (
  modeId,
  isDropOff,
  transferLongName,
  transferGooglePlaceId,
  departureDateTime,
  returnDateTime,
) => ({
  type: types.UPDATE_TRANSFER,
  modeId,
  isDropOff,
  transferLongName,
  transferGooglePlaceId,
  departureDateTime,
  returnDateTime,
})

export default {
  outboundDepartureTimesInitialized,
  inboundDepartureTimesInitialized,
  updateTransfer,
}
